module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"}
 ** module id = 2
 ** module chunks = 0
 **/